var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneRingingStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40932",
    "data-name": "Group 40932",
    transform: "translate(-334 -595)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15542",
    "data-name": "Rectangle 15542",
    width: 20,
    height: 20,
    transform: "translate(334 595)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(335.266 596.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_42",
    d: "M63.875,68.107c-5.933.192-16.6-10.393-11.645-16.139l.839-.728a2.243,2.243,0,0,1,3.152.034c.021.021,1.372,1.776,1.372,1.776a2.259,2.259,0,0,1,0,3.122l-.758.9a1.008,1.008,0,0,0-.132,1.09,9.294,9.294,0,0,0,4.17,4.179.993.993,0,0,0,1.09-.132l.907-.762a2.263,2.263,0,0,1,3.122,0s1.755,1.35,1.776,1.372a2.262,2.262,0,0,1,0,3.19l-.664.762A4.509,4.509,0,0,1,63.875,68.107Z",
    transform: "translate(-50.954 -50.609)",
    fill: "#af52de"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40919",
    "data-name": "Group 40919",
    transform: "translate(10.984)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37000",
    "data-name": "Path 37000",
    d: "M20,11h1a4,4,0,0,0-4-4V8A3,3,0,0,1,20,11Z",
    transform: "translate(-17 -4.5)",
    fill: "#af52de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37001",
    "data-name": "Path 37001",
    d: "M22.5,8.5h1A6.508,6.508,0,0,0,17,2V3A5.506,5.506,0,0,1,22.5,8.5Z",
    transform: "translate(-17 -2)",
    fill: "#af52de"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneRingingStatus);
export default __webpack_public_path__ + "static/media/phone-ringing-status.5ed2d92adbe56a208fe445a6167c6334.svg";
export { ForwardRef as ReactComponent };